import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, SpacingUnit } from 'components/ui';
import { useVerificationFormStore } from 'stores/local';

const VerificationButtonNodes = () => {
  const { t } = useTranslation();
  const { publishModal } = useVerificationFormStore();

  return (
    <SpacingRow hSpacing={SpacingUnit.unit2}>
      <Button type="primary" onClick={publishModal.modalState.open}>
        {t('common.publish')}
      </Button>
    </SpacingRow>
  );
};

export default observer(VerificationButtonNodes);
